import { Button } from '@creditornot/cb-button';
import { useQuery } from '@tanstack/react-query';
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { getActiveDeliverySettings } from 'apis/delivery-settings-api/api';
import { Venue } from 'apis/restaurant-api/merchant-admin/venue/types';
import DeliveryProviderModal from 'modules/venue/components/DeliveryProviderModal';

type Props = {
  className?: string;
  venue: Venue;
};

/** A button that triggers the same modal as in VenueDetails/DeliverySettings */
const DeliveryTypeSwitcher = ({ className, venue }: Props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { data: activeDeliverySettings, refetch: refetchActiveDeliverySettings } = useQuery(
    [`delivery-settings/${venue.id}`],
    () => getActiveDeliverySettings(venue.id),
    {
      retry: false,
      refetchOnWindowFocus: false,
    },
  );

  if (!activeDeliverySettings?.isFlexibleFulfillmentEnabled) {
    return null;
  }

  return (
    <>
      <Button
        variant="secondary"
        size="small"
        className={className}
        onClick={() => {
          setIsModalOpen(true);
        }}
      >
        <FormattedMessage id="venue-details.delivery-settings.change-delivery-type" />
      </Button>
      {isModalOpen && (
        <DeliveryProviderModal
          originView="live_purchases"
          venue={venue}
          currentDeliveryProvider={activeDeliverySettings.activeDeliverySettingsType}
          onClose={() => setIsModalOpen(false)}
          onSuccess={() => {
            refetchActiveDeliverySettings();
            setIsModalOpen(false);
          }}
        />
      )}
    </>
  );
};

export default DeliveryTypeSwitcher;
